/**
 * @file stockSupplier.js
 * @version 1.1.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-09-28
 * @modified 2026-10-02
 *
 * The store — H J Ward Agriculture — in supplier pickers: a STOCK tag, pinned
 * to the top, and findable by the words people actually type for it.
 *
 * Matched by Xero ContactID, as the server's utils/stockSupplier.js does, so a
 * rename or a near-namesake (the archived "H J Wards Agricultural Ltd") cannot
 * pick up the tag. This is the production tenant's id; in a sandbox tenant the
 * tag simply does not appear, which is harmless. Only the store is tagged, not
 * the Excel Agri Ltd company contact the server also counts as stock.
 */

const STORE_CONTACT_ID = '1219d24a-189f-47bc-9635-dd9f1f8b4375';

const STORE_SEARCH_WORDS = 'stock store hj h j ward wards';

// Every contact the server counts as stock (utils/stockSupplier.js there): the
// store, and the Excel Agri Ltd company contact. A line supplied by either is
// picked from our own stock, so nothing is bought for it.
const STOCK_CONTACT_IDS = [STORE_CONTACT_ID, 'da31e4a1-235c-4243-91d5-3bef802fd531'];

/** Is this contact row a stock supplier — nothing is bought from it? */
export const isStockSupplier = (contact) =>
  STOCK_CONTACT_IDS.includes(String(contact?.xero_contact_id || contact?.xeroContactId || '').trim().toLowerCase());

/** Is this contact row the store? Reads xero_contact_id (or xeroContactId). */
export const isStoreSupplier = (contact) =>
  String(contact?.xero_contact_id || contact?.xeroContactId || '').trim().toLowerCase() === STORE_CONTACT_ID;

/**
 * A supplier dropdown option, tagged and pinned when it is the store. Pass the
 * contact and the option the caller would have built anyway.
 */
export const withStoreTag = (contact, option) => (isStoreSupplier(contact)
  ? {
      ...option,
      tag: 'STOCK',
      pinned: true,
      searchText: `${option.searchText || option.label || ''} ${STORE_SEARCH_WORDS}`
    }
  : option);
